import React from 'react';
import InputControl from './InputControl';
import Adress from '../components/SDL/InputTypes/Adress';
import BirthDay from '../components/SDL/InputTypes/BirthDay';
import HouseMemberCount from '../components/SDL/InputTypes/HouseMemberCount';
import Number from '../components/SDL/InputTypes/Number';
import Ombudsnummer from '../components/SDL/InputTypes/Ombudsnummer';
import OrganizationNumber from '../components/SDL/InputTypes/OrganizationNumber';
import PersonNumber from '../components/SDL/InputTypes/PersonNumber';
import PersonNumberStudent from '../components/SDL/InputTypes/PersonNumberStudent';
import PostCode from '../components/SDL/InputTypes/PostCode';
import PreloadList from '../components/SDL/InputTypes/PreloadList';
import Price from '../components/SDL/InputTypes/Price';
import Registration from '../components/SDL/InputTypes/Registration';
import Text from '../components/SDL/InputTypes/Text';
import VehicleType from '../components/SDL/InputTypes/VehicleType';
import Year from '../components/SDL/InputTypes/Year';
import StreetAddress from '../components/SDL/InputTypes/StreetAddress';
import { useConfiguration } from '../providers/Configuration';

/**
 * Check which component type the current InputField is.
 * SDL specifies certain inputTypes which is both used to infer the type of control
 * but also the groupings, i.e the inputType "Address" can be 2 different components, and both of them should be hide/show based on that fact.
 * but the "Postcode" inputType is also included in that show/hide group.
 */
export default function InputType({ index, fieldCount = 0, form, ...props }) {
    return <TypeSwitch form={form} {...props}></TypeSwitch>;
}
function TypeSwitch({ inputType, components, form, ...props }) {
    const { configuration } = useConfiguration();

    switch (inputType) {
        case 'Address':
            switch (props.inputControl) {
                case 'DropDown':
                    return <Adress group={`address`} {...props} />;
                case 'TextField':
                    return <StreetAddress group={`address`} {...props} />;

                default:
                    return <Adress group={`address`} {...props} />;
            }
        case 'BirthDay':
            return <BirthDay {...props} />;
        case 'HouseMemberCount':
            return <HouseMemberCount {...props} />;
        case 'Number':
            return <Number {...props} />;
        case 'Ombudsnummer':
            return <Ombudsnummer {...props} />;
        case 'OrganizationNumber':
            return <OrganizationNumber {...props} />;
        case 'PersonNumber':
            return <PersonNumber {...props} />;
        case 'PersonNumberStudent':
            return <PersonNumberStudent {...props} />;
        case 'Postcode':
            return <PostCode group={`address`} {...props} />;
        case 'PreloadList':
            return <PreloadList categoryServiceUrl={configuration?.componentData?.categoryServiceUrl} {...props} />;
        case 'Price':
            return <Price {...props} />;
        case 'Registration':
            return <Registration {...props} />;
        case 'Text':
            return <Text {...props} />;
        case 'Vehicle Type':
            return <VehicleType {...props} />;
        case 'Year':
            return <Year {...props} />;
        default:
            // This has mappings to the base inputControl values, such as TextInput, DropDown etc..
            return <InputControl form={form} {...props} />;
    }
}
